export default "__VITE_ASSET__JS0pw8OF__"